import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PayOptions from "./PayOptions";
import * as accountActions from "Actions/accountActions";

function mapStateToProps(state) {
    return {
        accounts: state.accounts.accounts,
        isIEFlag: state.accounts.isIEFlag,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(accountActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PayOptions);



// WEBPACK FOOTER //
// ./src/components/atomic/molecules/PayOptions/index.js